module.exports = __webpack_public_path__ + "static/media/Geruza.bc44f05d.jpg";